import React, { useEffect } from 'react';
import OrderLookup from '../components/OrderLookup';
import ItemSelection from '../components/ItemSelection';
import ReturnTypeSelection from '../components/ReturnTypeSelection';
import NotesForm from '../components/NotesForm';
import SubmitRequest from '../components/SubmitRequest';
import ThankYou from '../components/ThankYou';
import { useReturnContext } from '../context/ReturnContext';
import './HomePage.css';

function HomePage() {
  const { 
    step, 
    setStep, 
    orderData, 
    setOrderData, 
    selectedItems, 
    setSelectedItems, 
    returnType, 
    setReturnType, 
    notes, 
    setNotes, 
    submitted, 
    setSubmitted,
    resetReturnState
  } = useReturnContext();

  // Check if we need to reset the form (e.g., when user refreshes after completion)
  useEffect(() => {
    if (submitted && step === 1) {
      resetReturnState();
    }
  }, [submitted, step, resetReturnState]);

  const handleOrderFound = (order) => {
    setOrderData(order);
    setStep(2);
  };

  const handleItemsSelected = (items) => {
    setSelectedItems(items);
    setStep(3);
  };

  const handleReturnTypeSelected = (type) => {
    setReturnType(type);
    setStep(4);
  };

  const handleNotesSubmitted = (noteText) => {
    setNotes(noteText);
    setStep(5);
  };
  
  // Navigate back to previous steps while preserving state
  const goToStep = (stepNumber) => {
    setStep(stepNumber);
  };

  const handleRequestSubmitted = () => {
    setSubmitted(true);
    setStep(6);
  };
  
  // Reset form when starting a new return
  const handleStartNewReturn = () => {
    resetReturnState();
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return <OrderLookup onOrderFound={handleOrderFound} />;
      case 2:
        return <ItemSelection order={orderData} onItemsSelected={handleItemsSelected} onBack={() => setStep(1)} />;
      case 3:
        return <ReturnTypeSelection onTypeSelected={handleReturnTypeSelected} onBack={() => setStep(2)} />;
      case 4:
        return <NotesForm onNotesSubmitted={handleNotesSubmitted} onBack={() => setStep(3)} />;
      case 5:
        return (
          <SubmitRequest
            order={orderData}
            items={selectedItems}
            returnType={returnType}
            notes={notes}
            onRequestSubmitted={handleRequestSubmitted}
            onBack={() => setStep(4)}
          />
        );
      case 6:
        return <ThankYou orderNumber={orderData?.name} />;
      default:
        return <OrderLookup onOrderFound={handleOrderFound} />;
    }
  };

  return (
    <div className="app fade-in">
      <main className="app-container">
        <div className="page-wrapper">
          {!submitted && (
            <div className="progress-indicator mb-8">
              <div className="steps d-flex justify-content-between mb-2">
                <span className={`step ${step >= 1 ? 'active' : ''}`}>Order Lookup</span>
                <span className={`step ${step >= 2 ? 'active' : ''}`}>Select Items</span>
                <span className={`step ${step >= 3 ? 'active' : ''}`}>Return Type</span>
                <span className={`step ${step >= 4 ? 'active' : ''}`}>Notes</span>
                <span className={`step ${step >= 5 ? 'active' : ''}`}>Submit</span>
              </div>
              <div className="progress">
                <div 
                  className="progress-bar" 
                  style={{ width: `${(step / 5) * 100}%` }}
                ></div>
              </div>
            </div>
          )}
          
          <div className="page-section slide-in">
            {renderStep()}
          </div>
        </div>
      </main>
    </div>
  );
}

export default HomePage;
